import React from "react";
import AllPricelists from "./PricelistModule/AllPricelists";

const Pricelists = () => {
  return (
    <div>
      <AllPricelists />
    </div>
  );
};

export default Pricelists;
